import { getSVGIcon } from "../../../utilities/globalUtilities";
import { PRICETYPES } from "../../../utilities/constants";

/**
 * Defines the HTML for product name
 * @param {Object} product
 */
const defineHTMLForProductName = product => {
    const {productName} = product;
    const productNameHTML = `<h1 class="product-name pwc-h3 mb-0">${productName}</h1>`;

    return productNameHTML;
};

/**
 * Defines the HTML for product description
 * @param {Object} product
 */
const defineHTMLForProductDescription = product => {
    const {shortDescription} = product;
    return `<p class="short-description">${shortDescription || ""}</p>`;
};

/**
 * Updates the product additional information section
 * @param {object} product - `product` object from the response, that contains the information needed
 */
const defineHTMLForProductAdditionalInfo = product => {
    const isPromoTimeResponse = product.badgeInfo?.promo != undefined && product.badgeInfo?.promo?.promoTime !== "" && product.badgeInfo?.promo?.type != PRICETYPES.PVPR;
    const promoTimeHTML = isPromoTimeResponse ? `
        <div class="product-promo-time--wrapper ct-pdp--promo-time-wrapper pwc-mt--10">
            <div class="ct-pdp--promo-time">
                ${isPromoTimeResponse ? getSVGIcon("icon-calendar") : ""}
                <span class="ct-pdp--promo-time-text">
                    ${isPromoTimeResponse ? product.badgeInfo.promo.promoTime : ""}
                </span>
            </div>
        </div>
    ` : "";

    const isDeliveryTime = product?.deliveryTime != undefined;
    const deliveryTimeHTML = isDeliveryTime ? `
        <div class="product-delivery--wrapper ct-pdp--delivery-wrapper pwc-mt--10">
            <div class="ct-pdp--delivery-time">
                ${product.deliveryTime}
            </div>
        </div>
    ` : "";

    const additionalInfoHTML = `
        <div class="ct-pdp--additional-info">
            ${promoTimeHTML}
            ${deliveryTimeHTML}
        </div>
    `;

    return isPromoTimeResponse || isDeliveryTime ? additionalInfoHTML : "";
};

/**
 * Defines the HTML for pdp redirect CTA
 * @param {Object} product
 * @param {Object} resources
 * @param {String} brandID
 */
const defineHTMLForProductRedirect = (product, resources, brandID) => {
    let urlUtils = require("../../../search/urlUtils");
    let {productURL, adjustedSelectedProductUrl} = product;
    adjustedSelectedProductUrl = adjustedSelectedProductUrl && adjustedSelectedProductUrl.includes("undefined") ? urlUtils.removeFromUrl(adjustedSelectedProductUrl, "quantity") : adjustedSelectedProductUrl;
    const URL = !adjustedSelectedProductUrl || adjustedSelectedProductUrl.includes("undefined") ? productURL : adjustedSelectedProductUrl;

    return `
        <div class="d-flex align-items-center m-0 see-details-wrapper w-100" data-pid="${product.id}">
            <a href="${URL}" class="w-100 button button--secondary ${brandID}-button ${brandID}-button--secondary see-details">${resources.seeDetailsLabel}</a>
        </div>
    `;
};

/**
 * Defines the HTML for product brand
 * @param {Object} product
 */
const defineHTMLForProductBrand = product => {
    const {brand} = product;
    const brandHTML =
        `<span class="ct-pdp--brand d-block">${brand || ""}</span>`;

    return brandHTML;
};

/**
 * Defines the HTML for product measurement note
 * @param {Object} product
 */
const defineHTMLForProductMeasurement = product => {
    const {measurementNote} = product;
    const measurementHTML = `<span class="ct-pdp--unit d-block">${measurementNote || ""}</span>`;

    return measurementHTML;
};

export {
    defineHTMLForProductName,
    defineHTMLForProductDescription,
    defineHTMLForProductAdditionalInfo,
    defineHTMLForProductBrand,
    defineHTMLForProductMeasurement,
    defineHTMLForProductRedirect
};
